module.exports = __webpack_public_path__ + "static/media/gallery-10.76d17955.jpg";